import clsx from 'clsx';
import { FC, PropsWithChildren } from 'react';
import { Header } from '../Header/Header';
import { PageTitle } from '../PageTitle/PageTitle';
import styles from './style.module.css';

type Props = PropsWithChildren<{
  title?: string;
  hideHeader?: boolean;
}>;

export const PageContainer: FC<Props> = ({ children, title, hideHeader = false }) => {
  return (
    <div>
      {!hideHeader && <Header />}
      <div
        className={clsx({
          [styles.body]: true,
          [styles.headerless]: hideHeader,
        })}
      >
        {title && <PageTitle className={styles.title}>{title}</PageTitle>}
        {children}
      </div>
    </div>
  );
};
